import {useEffect, useState} from 'react';
import {DisplayAdContainer} from '../../../../../../common/containers/DisplayAdContainer/DisplayAdContainer';
import {twMerge} from '../../../../../../common/twMerge';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {useViewerInfoQuery} from '../../../../../../wrapper/viewerWrapper';
import {ZIndex} from '../type/ZIndex.enum';

export function TalkViewerDisplayAdContainer({
  seriesId,
  productId,
}: {
  seriesId: number;
  productId: number;
}) {
  const {isViewerEndExposed, isViewerMenuOpened, viewerMenuHeight} =
    useTypedSelector(state => ({
      isViewerMenuOpened: state.viewerMenu.isExposed,
      isViewerEndExposed: state.viewerEnd.isExposed,
      viewerMenuHeight: state.talkViewer.settings.viewerMenuHeight,
    }));

  const displayAd = useViewerInfoQuery({seriesId, productId}).data?.displayAd;
  // 최초에는 노출조건이 충족될 때 까지 da를 렌더링하지 않는다. da 최초 렌더링시에 adfit을 불러오게 되는데, 화면에 da element가 없으면 에러가 나서 da를 붙이지 못하기 때문
  const [shouldRenderDa, setShouldRenderDa] = useState(false);

  const shouldShowDisplayAd = !isViewerMenuOpened && !isViewerEndExposed;

  useEffect(() => {
    if (!shouldRenderDa && shouldShowDisplayAd) {
      setShouldRenderDa(true);
    }
  }, [shouldShowDisplayAd, shouldRenderDa]);

  if (!displayAd || !shouldRenderDa) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'fixed top-0 left-0 w-full bg-theme-bg-surface p-15pxr',
        (isViewerMenuOpened || isViewerEndExposed) &&
          'pointer-events-none invisible'
      )}
      style={{
        zIndex: ZIndex.ViewerMenu - 1,
        paddingTop: (viewerMenuHeight.safeAreaTop || 0) + 15,
      }}
    >
      <DisplayAdContainer displayAd={displayAd} />
    </div>
  );
}
